export const AIPromptApiTags = {
  AIPrompt: 'AIPrompt',
  AIPromptTypes: 'AIPromptTypes',
  AIPromptEval: 'AIPromptEval',
};
